"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.videoStyle = exports.uploadingStyle = exports.textStyle = exports.tableStyle = exports.menuItemStyle = exports.marginStyle = exports.loadingStyle = exports.imageStyle = exports.iconStyle = exports.formStyle = exports.chipStyle = exports.buttonStyle = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Color = {
  primary: '#E54DA3',
  primaryHover: '#D8318B',
  text: '#463C42',
  white: '#fff',
  whiteHover: '#F5F5F5',
  disabled: '#D7C4CF',
  line: '#9A9898',
  imageBorder: '#efdfef',
  success: '#4CD76C',
  secondary: '#7781F1',
  danger: '#f00'
}; // ボタンのスタイル ---
const buttonCommon = {
  padding: '8px 16px',
  borderRadius: '8px',
  cursor: {
    default: 'pointer',
    ':disabled': 'not-allowed'
  },
  fontWeight: 'bold'
};
const buttonStyle = exports.buttonStyle = {
  primary: {
    padding: "x1ff1495",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk x1s07b3s",
    fontWeight: "x117nqv4",
    border: "x1gs6z28",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "x7qr07y xp11qgg x119m3qo",
    color: "xmzmlnv",
    $$css: true
  },
  secondary: {
    padding: "x1ff1495",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk x1s07b3s",
    fontWeight: "x117nqv4",
    border: "xu11zhv",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "x83z2og xw9yija x119m3qo",
    color: "x1c8w31c",
    $$css: true
  },
  disabled: {
    padding: "x1ff1495",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1h6gzvc",
    fontWeight: "x117nqv4",
    border: "x1gs6z28",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "xoa7fcp",
    color: "xfungia",
    $$css: true
  }
};
const menuItemCommon = {
  padding: '16px',
  borderRadius: '16px',
  cursor: 'pointer',
  color: Color.text,
  backgroundColor: Color.white
};
const menuItemStyle = exports.menuItemStyle = {
  inactive: {
    padding: "x1tamke2",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xgqmno8",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk",
    color: "x1c8w31c",
    backgroundColor: "x83z2og",
    ":hover_color": "x1napmqm",
    ":hover_backgroundColor": "x1kh9y8j",
    $$css: true
  },
  active: {
    padding: "x1tamke2",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xgqmno8",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    cursor: "x1ypdohk",
    color: "xfungia",
    backgroundColor: "xzjis1k",
    $$css: true
  }
}; // テキストのスタイル
const textCommon = {
  fontFamily: '"Noto Sans JP", sans-serif',
  color: Color.text,
  letterSpacing: '4%',
  lineHeight: '24px'
};
const textBold = {
  fontWeight: 'bold'
};
const textStyle = exports.textStyle = {
  h1: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "xcgk4ki",
    fontWeight: "x117nqv4",
    fontSize: "x1s3cmhv",
    $$css: true
  },
  h2: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "xeqr9p9",
    fontWeight: "x117nqv4",
    fontSize: "x1ewwscv",
    $$css: true
  },
  h3: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "x1o2sk6j",
    fontWeight: "x117nqv4",
    fontSize: "xwsyq91",
    $$css: true
  },
  p1: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "x1o2sk6j",
    fontSize: "x1j61zf2",
    $$css: true
  },
  p1b: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "x1o2sk6j",
    fontWeight: "x117nqv4",
    fontSize: "x1j61zf2",
    $$css: true
  },
  paragraph: {
    whiteSpace: "x126k92a",
    $$css: true
  },
  paragraph1: {
    fontSize: "x1j61zf2",
    $$css: true
  },
  paragraph2: {
    fontSize: "xif65rj",
    $$css: true
  },
  paragraph3: {
    fontSize: "x1k6wstc",
    $$css: true
  },
  error: {
    fontFamily: "xyrdcqf",
    color: "x139clnc",
    letterSpacing: "xbeo8cz",
    lineHeight: "x1o2sk6j",
    fontSize: "xfifm61",
    $$css: true
  },
  center: {
    textAlign: "x2b8uid",
    $$css: true
  },
  clearLinkDecoration: {
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    color: "x1heor9g",
    $$css: true
  },
  white: {
    color: "xfungia",
    $$css: true
  }
}; // フォームのスタイル
const formCommon = {
  ...textCommon,
  fontSize: '16px',
  borderRadius: '8px',
  padding: '16px',
  boxSize: 'border-box',
  border: 'none',
  outline: {
    default: '1px solid ' + Color.text,
    ':hover:enabled': '2px solid ' + Color.primary
  },
  margin: 0,
  background: 'none',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none'
};
const formStyle = exports.formStyle = {
  text: {
    fontFamily: "xyrdcqf",
    color: "x1c8w31c",
    letterSpacing: "xbeo8cz",
    lineHeight: "x1o2sk6j",
    fontSize: "x1j61zf2",
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1tamke2",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    boxSize: "xbi24iw",
    border: "x1gs6z28",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    outline: "x1yva9qc xi0qnmi",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    background: "x11g6tue",
    backgroundAttachment: null,
    backgroundClip: null,
    backgroundColor: null,
    backgroundImage: null,
    backgroundOrigin: null,
    backgroundPosition: null,
    backgroundPositionX: null,
    backgroundPositionY: null,
    backgroundRepeat: null,
    backgroundSize: null,
    "-webkit-appearance": "x1lugfcp",
    "-moz-appearance": "x12s6a5a",
    appearance: "xjyslct",
    width: "xh8yej3",
    boxSizing: "x9f619",
    $$css: true
  },
  checkbox: {
    cursor: "x1ypdohk",
    $$css: true
  },
  textarea: {
    height: "x1m3v4wt",
    $$css: true
  },
  file: {
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    outline: "x1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    "::file-selector-button_padding": "x6arkyc",
    "::file-selector-button_paddingInline": null,
    "::file-selector-button_paddingStart": null,
    "::file-selector-button_paddingLeft": null,
    "::file-selector-button_paddingEnd": null,
    "::file-selector-button_paddingRight": null,
    "::file-selector-button_paddingBlock": null,
    "::file-selector-button_paddingTop": null,
    "::file-selector-button_paddingBottom": null,
    "::file-selector-button_borderRadius": "x1kuyeia",
    "::file-selector-button_borderStartStartRadius": null,
    "::file-selector-button_borderStartEndRadius": null,
    "::file-selector-button_borderEndStartRadius": null,
    "::file-selector-button_borderEndEndRadius": null,
    "::file-selector-button_borderTopLeftRadius": null,
    "::file-selector-button_borderTopRightRadius": null,
    "::file-selector-button_borderBottomLeftRadius": null,
    "::file-selector-button_borderBottomRightRadius": null,
    "::file-selector-button_cursor": "xjmbuqf xp8nyaq",
    "::file-selector-button_fontWeight": "x1m790ez",
    "::file-selector-button_border": "x5sjcyb",
    "::file-selector-button_borderWidth": null,
    "::file-selector-button_borderInlineWidth": null,
    "::file-selector-button_borderInlineStartWidth": null,
    "::file-selector-button_borderLeftWidth": null,
    "::file-selector-button_borderInlineEndWidth": null,
    "::file-selector-button_borderRightWidth": null,
    "::file-selector-button_borderBlockWidth": null,
    "::file-selector-button_borderTopWidth": null,
    "::file-selector-button_borderBottomWidth": null,
    "::file-selector-button_borderStyle": null,
    "::file-selector-button_borderInlineStyle": null,
    "::file-selector-button_borderInlineStartStyle": null,
    "::file-selector-button_borderLeftStyle": null,
    "::file-selector-button_borderInlineEndStyle": null,
    "::file-selector-button_borderRightStyle": null,
    "::file-selector-button_borderBlockStyle": null,
    "::file-selector-button_borderTopStyle": null,
    "::file-selector-button_borderBottomStyle": null,
    "::file-selector-button_borderColor": null,
    "::file-selector-button_borderInlineColor": null,
    "::file-selector-button_borderInlineStartColor": null,
    "::file-selector-button_borderLeftColor": null,
    "::file-selector-button_borderInlineEndColor": null,
    "::file-selector-button_borderRightColor": null,
    "::file-selector-button_borderBlockColor": null,
    "::file-selector-button_borderTopColor": null,
    "::file-selector-button_borderBottomColor": null,
    "::file-selector-button_backgroundColor": "xp2ecih x1l0cax9 x1p1t00a",
    "::file-selector-button_color": "x1i38x7j",
    $$css: true
  },
  previewImage: {
    width: "xdzyupr",
    $$css: true
  }
}; // ラッパーのスタイル
const sidebarWidth = 300;
const wrapper = exports.wrapper = {
  fill: {
    width: "xn9wirt",
    height: "x1dr59a3",
    $$css: true
  },
  stretchW: {
    width: "xh8yej3",
    $$css: true
  },
  stretch: {
    width: "xh8yej3",
    height: "x5yr21d",
    $$css: true
  },
  center: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    $$css: true
  },
  sidebarOuter: {
    width: "xdzyupr",
    borderRight: "x1wobtje",
    borderRightWidth: null,
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderRightStyle: null,
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderRightColor: null,
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    $$css: true
  },
  sidebarInner: {
    padding: "x1tw7de1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "x83z2og",
    $$css: true
  },
  main: {
    width: "xfl88ou",
    height: "x5yr21d",
    padding: "x1d6rxua",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    alignItems: "x7a106z",
    $$css: true
  },
  noSidebar: {
    margin: "x1bpp3o7",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  mainTitle: {
    width: "xh8yej3",
    justifyContent: "x1qughib",
    alignItems: "x6s0dn4",
    $$css: true
  },
  tableHeader: {
    display: "x78zum5",
    justifyContent: "x1qughib",
    $$css: true
  },
  detailImage: {
    height: "x1ymw6g",
    $$css: true
  },
  course: {
    width: "x1602a87",
    corsor: "x18jene9",
    padding: "x1vh3k5j",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    ":hover_backgroundColor": "x1kh9y8j",
    $$css: true
  },
  examResult: {
    padding: "x15fnm84",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "xur7f20",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    textAlign: "x2b8uid",
    $$css: true
  },
  examPassed: {
    backgroundColor: "xsr8tqr",
    color: "xfungia",
    $$css: true
  },
  examFailed: {
    backgroundColor: "x7qr07y",
    color: "xfungia",
    $$css: true
  },
  flexCenter: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    $$css: true
  },
  video: {
    position: "x1n2onr6",
    width: "xh8yej3",
    height: "x1l5p03z",
    $$css: true
  },
  statusChip: {
    position: "x1n2onr6",
    $$css: true
  }
};
const tableStyle = exports.tableStyle = {
  container: {
    height: "x5yr21d",
    $$css: true
  },
  row: {
    borderBottom: "x1vxx3qh",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  },
  cell: {
    padding: "x7z7khe",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    $$css: true
  },
  bodyCell: {
    verticalAlign: "x16dsc37",
    height: "x1ymw6g",
    $$css: true
  },
  centerCell: {
    textAlign: "x2b8uid",
    verticalAlign: "xxymvpz",
    $$css: true
  },
  smallCell: {
    height: "x1wkxgih",
    $$css: true
  }
};
const fadeIn = "x18re5ia-B";
const fadeOut = "x1jn504y-B";
const loadingStyle = exports.loadingStyle = {
  wrapper: {
    position: "xixxii4",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    backgroundColor: "x10lwa08",
    display: "x78zum5",
    justifyContent: "xl56j7k",
    alignItems: "x6s0dn4",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  appear: {
    display: "x78zum5",
    animationName: "xqcmdr3",
    animationDuration: "x1q3qbx4",
    animationFillMode: "x10e4vud",
    pointerEvents: "x67bb7w",
    $$css: true
  },
  disappear: {
    animationName: "xxp0q0x",
    animationDuration: "x1q3qbx4",
    animationFillMode: "x10e4vud",
    pointerEvents: "x47corl",
    $$css: true
  },
  icon: {
    width: "xxljpkc",
    $$css: true
  },
  message: {
    color: "xfungia",
    $$css: true
  }
};
const uploadingStyle = exports.uploadingStyle = {
  wrapper: {
    position: "xixxii4",
    width: "x1oysuqx",
    height: "xpyat2d",
    right: "x131sewu",
    insetInlineStart: null,
    insetInlineEnd: null,
    bottom: "x1jn9clo",
    backgroundColor: "x15hks01",
    display: "x78zum5",
    justifyContent: "xl56j7k",
    alignItems: "x6s0dn4",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  appear: {
    display: "x78zum5",
    animationName: "xqcmdr3",
    animationDuration: "x1q3qbx4",
    animationFillMode: "x10e4vud",
    pointerEvents: "x67bb7w",
    $$css: true
  },
  disappear: {
    animationName: "xxp0q0x",
    animationDuration: "x1q3qbx4",
    animationFillMode: "x10e4vud",
    pointerEvents: "x47corl",
    $$css: true
  },
  icon: {
    width: "xxljpkc",
    $$css: true
  },
  message: {
    color: "xfungia",
    $$css: true
  }
};
const imageStyle = exports.imageStyle = {
  courseList: {
    width: "xktia5q",
    height: "x1io82uz",
    objectFit: "x19kjcj4",
    $$css: true
  },
  courseCard: {
    maxWidth: "x193iq5w",
    maxHeight: "x1rvw3h8",
    minHeight: "xjqcprk",
    borderRadius: "x12oqio5",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    objectFit: "x19kjcj4",
    backgroundColor: "x18jlpol",
    boxShadow: "x183nn2y",
    $$css: true
  },
  courseDetail: {
    width: "xh8yej3",
    height: "x1bo65i3",
    objectFit: "xl1xv1r",
    $$css: true
  },
  detail: {
    height: "x5yr21d",
    objectFit: "x19kjcj4",
    $$css: true
  },
  fade: {
    animationName: "xqcmdr3",
    animationDuration: "x1q3qbx4",
    animationFillMode: "x10e4vud",
    $$css: true
  },
  logo: {
    width: "x14atkfc",
    $$css: true
  }
};
const chipStyle = exports.chipStyle = {
  common: {
    border: "xk7imp5",
    borderWidth: "x9r2w2z",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1ym1fkr",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xnut2p4",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    width: "x1d7z9mz",
    height: "xn3w4p2",
    display: "x78zum5",
    justifyContent: "xl56j7k",
    alignItems: "x6s0dn4",
    fontWeight: "x117nqv4",
    fontSize: "xosj86m",
    $$css: true
  },
  inactive: {
    color: "x1c8w31c",
    borderColor: "x5e7zdm",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "x83z2og",
    $$css: true
  },
  during: {
    color: "x1aeym4s",
    borderColor: "xcq1rd",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "x83z2og",
    $$css: true
  },
  active: {
    color: "xfungia",
    borderColor: "x1qbrpkz",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "xsr8tqr",
    $$css: true
  },
  status: {
    position: "x10l6tqk",
    top: "x1eu8d0j",
    left: "x12lbrt0",
    insetInlineStart: null,
    insetInlineEnd: null,
    borderRadius: "x1ijmkg9",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  statusDuring: {
    backgroundColor: "x162w3ef",
    color: "xfungia",
    $$css: true
  },
  statusYet: {
    backgroundColor: "x7qr07y",
    color: "xfungia",
    $$css: true
  },
  statusCompleted: {
    backgroundColor: "xsr8tqr",
    color: "xfungia",
    $$css: true
  },
  statusPassed: {
    backgroundColor: "xoa7fcp",
    color: "xfungia",
    $$css: true
  }
};
const videoStyle = exports.videoStyle = {
  main: {
    width: "xh8yej3",
    height: "x5yr21d",
    $$css: true
  },
  modal: {
    position: "x10l6tqk",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    backgroundColor: "xcpsgoo",
    color: "xfungia",
    display: "x78zum5",
    justifyContent: "xl56j7k",
    alignItems: "x6s0dn4",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  modalItem: {
    margin: "x1k3vv4n",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  }
};
const marginStyle = exports.marginStyle = {
  top: {
    marginTop: "x11fxgd9",
    $$css: true
  }
};
const iconStyle = exports.iconStyle = {
  correct: {
    color: "x1ukjc6b",
    $$css: true
  },
  incorrect: {
    color: "xadjkbh",
    $$css: true
  }
};